import { FormEvent, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { ErrorBox } from '../components/Feedback';
import { useAuth } from '../lib/auth';

export function LoginPage() {
  const { user, login } = useAuth(); const navigate = useNavigate(); const location = useLocation();
  const [username, setUsername] = useState(''); const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false); const [error, setError] = useState('');
  if (user) return <Navigate to="/" replace />;
  async function submit(event: FormEvent) {
    event.preventDefault(); setBusy(true); setError('');
    try { await login(username.trim(), password); const from = (location.state as { from?: string } | null)?.from; navigate(from || '/', { replace: true }); }
    catch (reason) { setError(reason instanceof Error ? reason.message : 'Autentificarea a eșuat'); }
    finally { setBusy(false); }
  }
  return <div className="login-page">
    <div className="login-glow login-glow--top" aria-hidden="true" />
    <div className="login-glow login-glow--bottom" aria-hidden="true" />
    <main className="login-body">
      <header className="login-brand">
        <div className="login-logo"><img src="/orasesta-logo.png" alt="Orasesta" /></div>
        <h1>Support Tehnic</h1>
        <p>Nova Prompt · Gruppo Orasesta</p>
      </header>
      <form onSubmit={submit}>
        <div className="login-panel">
          <h2>Autentificare</h2>
          {error && <ErrorBox message={error} />}
          <div className="login-field">
            <label className="input-label" htmlFor="login-email">Email</label>
            <input id="login-email" className="input" type="email" inputMode="email" placeholder="nume@firma.ro" autoComplete="email" autoCapitalize="none" spellCheck={false} required disabled={busy} value={username} onChange={(event) => setUsername(event.target.value)} />
          </div>
          <div className="login-field login-field--last">
            <label className="input-label" htmlFor="login-password">Parolă</label>
            <input id="login-password" className="input" type="password" placeholder="••••••••" autoComplete="current-password" required disabled={busy} value={password} onChange={(event) => setPassword(event.target.value)} />
          </div>
          <button type="submit" className="btn btn-primary btn-block btn-lg" disabled={busy || !username || !password}>{busy ? 'Se conectează…' : 'Intră în cont'}</button>
        </div>
      </form>
      <p className="login-footer">© {new Date().getFullYear()} Nova Prompt SRL</p>
    </main>
  </div>;
}
